import React, { useEffect, useState } from 'react';
import { Justify, Form, Input, Button, Checkbox } from 'tea-component';
import * as service from '@/pages/home/services/login';
import {
  visRegisterWeb,
  isValidEmail,
  isEmptyValue,
  isValidGsv,
} from '../_config/common';
import { useIntl } from 'umi';
import { MIN_PASSWORD_LEN, MAX_PASSWORD_LEN } from '../_config/constant';
import { encryptedInfo } from '@/pages/home/utils/frontEncryption';

export default function EmailLogin(props: any) {
  const {
    oaLoading,
    email,
    password,
    getEmailBtn,
    getRegister,
    getForgetPassword,
    login14Days,
    setLogin14Days,
    onError = () => console.log,
  } = props;
  const { formatMessage } = useIntl();
  // 邮箱
  const [statusEmail, setStatusEmail] = useState<string | null>(null);
  const [valueEmail, setValueEmail] = useState<string>('');
  const [successEmail, setSuccessEmail] = useState(false);

  // 密码
  const [statusPadssword, setStatusPadssword] = useState<string | null>(null);
  const [valuePadssword, setValuePadssword] = useState<string>('');

  useEffect(() => {
    /** 从外面传过来的时候空值不做校验 */
    if (email) {
      onEmailBuleClick(email);
    }
    setValueEmail(email);
    if (password) {
      onPadsswordBuleClick(password);
    }
    setValuePadssword(password);
  }, [email, password]);

  // 邮件
  const onEmailChangClick = (val: string) => {
    setValueEmail(val);
  };
  const onEmailBuleClick = (email = valueEmail, password = valuePadssword) => {
    // 浏览器记录账户密码时，账户更新同时验证密码
    if (password) {
      onPadsswordBuleClick(password);
    }

    if (isEmptyValue(email)) {
      setStatusEmail('dbh_login_no_email_entered');
      setSuccessEmail(false);
      return false;
    } else if (isValidEmail(email)) {
      setStatusEmail(null);
      setSuccessEmail(true);
      return true;
    } else {
      setStatusEmail('dbh_login_email_format_error');
      setSuccessEmail(false);
      return false;
    }
  };
  // 密码
  const onPadsswordChangClick = (val: string) => {
    setValuePadssword(val);
  };
  const onPadsswordBuleClick = (password = valuePadssword) => {
    if (!password) {
      setStatusPadssword('dbh_login_no_password_enter');
      return false;
    } else if (isValidGsv(valuePadssword)) {
      setStatusPadssword('dbh_login_format_gsv');
    } else {
      setStatusPadssword(null);
      return true;
    }
  };

  // 登陆
  const [loading, setLoading] = useState(false);

  const onEmailLogin = async () => {
    if (loading) {
      return;
    }
    const _successEmail = onEmailBuleClick();
    const _successPadssword = onPadsswordBuleClick();
    if (!_successEmail || !_successPadssword) {
      return;
    }
    setLoading(true);
    try {
      // 密码加密
      const turnPassword = await encryptedInfo(valuePadssword);
      const res = await service.login({
        login_type: 'Email',
        email: valueEmail,
        password: turnPassword,
      });
      const expired = res.expired;
      getEmailBtn(valueEmail, valuePadssword, expired);
    } catch (err: any) {
      if (err?.code === 4007) {
        // 4007 Login failed
        setStatusEmail('dbh_login_error_no_message');
        setSuccessEmail(false);
        setStatusPadssword('dbh_login_error_email');
      } else {
        onError(err?.msg, err?.code);
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="login-cont-email">
      <div className="login-cont-title">
        {formatMessage({ id: 'dbh_login_email_login' })}
      </div>
      <div className="login-cont-account">
        {/* 邮箱登录 */}
        <Form.Item
          label={formatMessage({ id: 'dbh_login_email' })}
          status={successEmail ? 'success' : statusEmail ? 'error' : undefined}
          message={statusEmail ? formatMessage({ id: statusEmail }) : undefined}
        >
          <Input
            placeholder={formatMessage({ id: 'dbh_login_email_placeholder' })}
            value={valueEmail}
            onChange={(val) => {
              onEmailChangClick(val);
            }}
            onBlur={() => {
              onEmailBuleClick(valueEmail);
            }}
          />
        </Form.Item>

        <>
          <Form.Item
            label={formatMessage({ id: 'dbh_login_password' })}
            status={
              /* successPadssword ? 'success' : */ statusPadssword
                ? 'error'
                : undefined
            }
            message={
              statusPadssword
                ? statusPadssword === 'dbh_login_password_format'
                  ? formatMessage(
                    { id: 'dbh_login_password_format' },
                    { min: MIN_PASSWORD_LEN, max: MAX_PASSWORD_LEN },
                  )
                  : formatMessage({ id: statusPadssword })
                : undefined
            }
          >
            <Input
              type="password"
              placeholder={formatMessage({
                id: 'dbh_login_password_placeholder',
              })}
              value={valuePadssword}
              onChange={(val) => {
                onPadsswordChangClick(val);
              }}
              onBlur={() => {
                onPadsswordBuleClick(valuePadssword);
              }}
            />
          </Form.Item>
        </>
      </div>
      <Checkbox
        className="db-login-14days-box"
        value={login14Days}
        onChange={(value) => {
          setLogin14Days(value);
        }}
        display="block"
      >
        {formatMessage({ id: 'dbh_14_days_login' })}
      </Checkbox>
      <div
        className="login-cont-from-btn"
        onClick={() => {
          onEmailLogin();
        }}
      >
        <Button type="primary" loading={loading || oaLoading}>
          {formatMessage({ id: 'dbh_login' })}
        </Button>
      </div>
      <Justify
        left={
          visRegisterWeb.includes(window.location.host) && (
            <Button
              type="link"
              className="login-cont-from-info"
              onClick={getRegister}
            >
              <span> {formatMessage({ id: 'dbh_login_register' })}</span>
            </Button>
          )
        }
        right={
          <Button
            type="link"
            className="login-cont-from-info"
            onClick={() => getForgetPassword(valueEmail, valuePadssword)}
          >
            <span>{formatMessage({ id: 'dbh_login_is_forget_password' })}</span>
          </Button>
        }
      ></Justify>
    </div>
  );
}
